import { render } from "./RankBodyMixins.vue?vue&type=template&id=04a48c02"
import script from "./RankBodyMixins.vue?vue&type=script&lang=js"
export * from "./RankBodyMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__